import { render, staticRenderFns } from "./Textbook.vue?vue&type=template&id=f91d3e4a&scoped=true"
import script from "./Textbook.vue?vue&type=script&lang=js"
export * from "./Textbook.vue?vue&type=script&lang=js"
import style0 from "./Textbook.vue?vue&type=style&index=0&id=f91d3e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91d3e4a",
  null
  
)

export default component.exports